import { navLinks } from "@/mocks/guatrend";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-50/80">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="inline-flex items-center gap-2.5">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-seedling-line text-lg"></i>
              </span>
              <span className="font-display text-2xl text-background-50">吃瓜精选</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/70">
              以真实网友反馈与评分为核心的内容甄选站。收集评分与口碑，逐期整理高分合集，只留下真正值得一看的优质好瓜。口碑之选，放心食用。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-douban-line", label: "豆瓣" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#submit"
                  aria-label={s.label}
                  rel="nofollow"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50/80 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">栏目导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="transition-colors hover:text-primary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-50/70">
              <li className="flex items-center gap-2 whitespace-nowrap">
                <i className="ri-mail-line text-primary-300"></i>
                hi@chigua.jingxuan
              </li>
              <li className="flex items-center gap-2 whitespace-nowrap">
                <i className="ri-time-line text-primary-300"></i>
                每日 09:00 - 21:00
              </li>
              <li className="flex items-center gap-2 whitespace-nowrap">
                <i className="ri-map-pin-line text-primary-300"></i>
                网友遍布全网，线上甄选
              </li>
              <li>
                <a href="#submit" className="mt-1 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-2 text-xs font-medium text-background-50 hover:bg-accent-600">
                  <i className="ri-edit-2-line"></i>
                  推荐好瓜
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-50/60 sm:flex-row md:px-6">
          <p>© 2026 吃瓜精选 · 口碑之选，放心食用</p>
          <p className="text-background-50/50">真实网友评分沉淀 · 高分合集持续甄选中</p>
        </div>
      </div>
    </footer>
  );
}